module.exports = __webpack_public_path__ + "img/dashboard-graphic1.2e3f5c78.png";